export var RegistryType;
(function (RegistryType) {
    RegistryType["Github"] = "github";
    RegistryType["FileSystem"] = "filesystem";
    RegistryType["Merged"] = "merged";
    RegistryType["Partial"] = "partial";
})(RegistryType || (RegistryType = {}));
